import React, { useRef } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import { Undo2, Redo2 } from 'lucide-react';

/* Simple WYSIWYG for non-developers (Phase 93).
   Formatting: bold / italic / underline / strikethrough
   Structure: H2 / H3 / paragraph / bullets / numbers
   Links: add, edit, remove (Quill link tool)
   Editing: undo / redo / clear formatting
   Extras: alignment, blockquote, divider (where allowed)
   The site's typography is preserved: arbitrary fonts/colours are not offered,
   and the server sanitizes saved HTML for safety. */

const modules = {
  toolbar: [
    [{ header: [2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ align: [] }],
    ['link', 'image'],
    ['blockquote'],
    ['clean'],
  ],
  history: { delay: 400, maxStack: 200, userOnly: true },
};

const formats = ['header', 'bold', 'italic', 'underline', 'strike', 'link',
  'image', 'list', 'blockquote', 'align'];

export const RichTextEditor = ({ value, onChange, placeholder = 'Write content here…' }) => {
  const quillRef = useRef(null);
  const history = (fn) => {
    const q = quillRef.current?.getEditor?.();
    if (q) q.history[fn]();
  };
  return (
    <div className="w8-editor" data-testid="rich-text-editor">
      <div className="flex items-center gap-1 px-2 py-1 bg-slate-50 border border-b-0 border-slate-200 rounded-t-lg">
        <button type="button" onClick={() => history('undo')} title="Undo" aria-label="Undo"
          className="p-1.5 rounded hover:bg-slate-200 text-slate-600" data-testid="rich-editor-undo">
          <Undo2 className="h-3.5 w-3.5" />
        </button>
        <button type="button" onClick={() => history('redo')} title="Redo" aria-label="Redo"
          className="p-1.5 rounded hover:bg-slate-200 text-slate-600" data-testid="rich-editor-redo">
          <Redo2 className="h-3.5 w-3.5" />
        </button>
        <span className="text-[10px] text-slate-400 ml-1">Undo / Redo</span>
      </div>
      <ReactQuill ref={quillRef} theme="snow" value={value || ''} onChange={onChange} modules={modules} formats={formats} placeholder={placeholder} />
    </div>
  );
};

export default RichTextEditor;
